<template>
    <div class="col-md-5 p-0">
        <div class="producticon" :class="{'added': success }" @click="add()"></div>

        <div class="modal fade show" tabindex="-1" role="dialog" v-if="showForm" style="display:block">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" aria-label="Close" @click="showForm = false"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <p>This item has options that need to be picked before you can proceed.</p>

                    <option-dropdown v-for="(option,name) in options" :key="name" :name="name" :options="option.data" @select-option="saveSelectedValue"></option-dropdown>

                    <div class="error" v-if="error">You must enter a value for all options</div>
                    <br><br>
                    <button @click="addToCart" class="btn btn-danger">Add to Cart</button>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" aria-labelledby="continueshopping" style="display:block" v-if="success && showSuccess">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Added to Cart</h5>
                        <button type="button" class="close" aria-label="Close" @click="showSuccess = false">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-footer">
                     <div class="row">
                    <div class="col-md">
                        <button type="button" class="btn btn-danger" @click="showSuccess = false">Continue Shopping</button>
                    </div>
                    <div class="col-md">
                        <a class="btn btn-danger" href="/cart">Proceed to Cart</a>
                        </div>
                    </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import OptionDropdown from './OptionDropdown.vue';
    import {ServiceFactory} from '../../../../../../shared/assets/js/services/ServiceFactory';

    const CartService = ServiceFactory.get('cart');

    export default {
        components: {OptionDropdown},
        props: ['productSlug', 'options'],

        data() {
            return {
                error: false,
                showForm: false,
                success: false,
                selected: {},
                showSuccess: false,
            }
        },

        methods: {
            add() {
                // only add if it hasn't already been quick added
                if (this.success === true) {
                    return;
                }

                if (!this.hasOptions()) {
                    this.addToCart();
                    return;
                }

                this.showForm = true;
            },

            async addToCart() {
                let missing = Object.keys(this.options)
                    .map((key, value) => key)
                    .filter(option => this.hasBeenSelected(option))

                if (missing.length) {
                    this.error = true;
                    return;
                }

                try {
                    CartService.quickAdd(this.productSlug, this.selected)
                    .then(() => {
                        this.success = true;
                        this.showForm = false;
                        this.showSuccess = true;
                        this.$store.commit('incrementCartCount');
                    });
                } catch (error) {
                    console.error(error);
                    return;
                }
            },


            saveSelectedValue(name, option) {
                this.error = false;
                this.selected[name] = option;
            },

            hasBeenSelected(option) {
                return this.selected[option] === undefined;
            },

            hasOptions() {
                return this.options.length !== 0;
            },

        },
    }
</script>
